import {useMedia} from "@hooks/ui/useMedia";
import {Box} from "@mui/material";
import {ReactNode} from "react";


const ToggleFullScreen = ({
							  fullScreenMode,
							  children
						  }: {
	fullScreenMode: boolean
	children: ReactNode
}) => {
	
	const {isDesktop} = useMedia()
	const gapWidth = isDesktop ? '15px' : '10px';
	const gapHeight = isDesktop ? '15px' : '95px';
	
	const size = isDesktop ? 95 : 100
	
	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				transition: 'all .3s',
				paddingBottom: {
					xs: '0',
					lg: '5px'
				},
				display: 'flex',
				flexDirection: 'column',
				paddingTop: '-10px',
				minWidth: {
					xs: fullScreenMode ? `calc(${size}vw - ${gapWidth})` : '60vw',
					lg: fullScreenMode ? `calc(${size}vw - ${gapWidth})` : 'auto'
				},
				minHeight: {
					xs: fullScreenMode ? `calc(${size}vh - ${gapHeight})` : '60vh',
					lg: fullScreenMode ? `calc(${size}vh - ${gapHeight})` : 'auto',
				},
				maxWidth: `calc(${size}vw - ${gapWidth})`,
				maxHeight: `calc(${size}vh - ${gapHeight})`,
			}}
		>
			{children}
		</Box>
	);
};

export default ToggleFullScreen;